import React from 'react';
import RimPanel from './RimPanel';
import BetaPanel from './BetaPanel';
import ControlPanelHeader from './ControlPanelHeader';


export default function ControlPanelV2() {

function displayHandlerRim() {
    
}

    return (
        <div className='configurator-page2'>
            {/* <ControlPanelHeader /> */}
            <RimPanel />
        </div>
    )
}
